import { interact, URLS } from "fire-wind-water";
import authService from "@/services/authService";
import { common } from "@/model/common";
import BaseComponent from "@/components/BaseComponent";
import configMixin from "@/mixin/config";
import Header from "@/components/Header";
import Banner from "@/components/Banner";

export default {
  name: "password",
  components: {
    BaseComponent,
    Header,
    Banner,
  },
  mixins: [configMixin],
  data() {
    return {
      memberFormId: common.memberFormId, //  表单ID
      memberSchemaId: common.memberSchemaId,
      schemaId: common.schemaId, // 体系ID
      wechatInfo: null,
      qqInfo: null,
      oauthInfo: null,
      uniqueList: [],
      isShowQQ: true,
      isShowWeChat: false,
      qq: -1,
      weChat: -1,
      mobile: -1,
      email: -1,
      unique: "",
      captcha: "",
      uniqueErrorMsg: "",
      captchaErrorMsg: "",
      count: 60,
      timer: null,
      isCodeLoad: false,
      placeHolderDisplayName: "",
      isSubmitting: false,
      isShowPhoneTips: false,
      captchaSignInErrorMsg: "",
    };
  },
  methods: {
    getCode() {
      this.uniqueErrorMsg = this.unique
        ? this.uniqueErrorMsg
        : `请输入${this.placeHolderDisplayName}`;
      if (this.uniqueErrorMsg) return;
      this.sendCheckCode();
    },
    sendCheckCode() {
      authService
        .sendCheckCode({
          unique: this.unique,
          memberSchemaId: this.schemaId,
          validTime: 600, //验证码的有效期。如果没传默认是600秒（10分钟）
          intervalTime: 60, //重发的间隔时间。如果没传默认是60秒（1分钟）。可用于界面倒计时
          action: "resetpassword", //应用场景，用途。默认值是all。login:登录，register:注册，resetpassword:重置或修改密码，all:所有场景下通用。目前只有这四种。以后不同场景用途发送的内容由后台短信或邮件模板定义（现在未实现，还是由后台代码实现的）
          browseInfo: interact.browseInfo,
          globalUserId: common.globalUserId,
        })
        .then((res) => {
          if (res.result != 0) return window.$sk.tips.show(res["desc"]);
          if (!this.timer) {
            this.isCodeLoad = true;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= 60) {
                this.count--;
              } else {
                this.isCodeLoad = false;
                this.count = 60;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        });
    },
    uniqueChange() {
      if (!this.unique) {
        return (this.uniqueErrorMsg = "请输入" + this.placeHolderDisplayName);
      }
      if (this.mobile >= 0 || this.email >= 0) {
        //如果有手机正则
        let reMobile = new RegExp(
          this.mobile >= 0 ? this.fieldList[this.mobile].regularExpression : ""
        );
        let reEmail = new RegExp(
          this.email >= 0 ? this.fieldList[this.email].regularExpression : ""
        );
        if (
          (!reMobile.test(this.unique) || this.mobile < 0) &&
          (!reEmail.test(this.unique) || this.email < 0)
        ) {
          this.uniqueErrorMsg = `请输入正确的${this.placeHolderDisplayName}格式`;
        } else {
          this.uniqueErrorMsg = "";
        }
      }
      return;
    },
    captchaChange() {
      return (this.captchaErrorMsg = this.captcha ? "" : "请输入验证码");
    },
    keySubmit(e) {
      if (e.keyCode == 13) {
        this.next();
      }
    },
    next() {
      let self = this;
      self.uniqueErrorMsg = self.unique
        ? self.uniqueErrorMsg
        : "请输入" + self.placeHolderDisplayName;
      self.captchaErrorMsg = self.captcha
        ? self.captchaErrorMsg
        : "请输入验证码";
      if (self.uniqueErrorMsg || self.captchaErrorMsg) return;
      self.isSubmitting = true;
      let params = {
        unique: self.unique, //可以是邮箱或者手机，由后端检查是什么格式
        memberSchemaId: self.memberSchemaId,
        checkCode: self.captcha,
        action: "resetpassword",
        globalUserId: common.globalUserId,
      };
      authService.checkCode(params).then(
        (data) => {
          self.isSubmitting = false;
          if (data.result == 0) {
            if (data.content.result) {
              common.setToken(data["content"]["token"]);
              // ck.cookie("token", data["content"]["token"]); //写入token
              common.routerPush(self, "setPassword");
            } else {
              self.captchaSignInErrorMsg = data["desc"];
            }
          } else {
            self.captchaSignInErrorMsg = data["desc"];
          }
        },
        (data) => {
          window.$sk.tips.show(data.desc);
          // self.captchaSignInErrorMsg = data["desc"]
          self.isSubmitting = false;
        }
      );
      // common.routerParamsPush(this, "setPassword");
    },
    load() {
      let self = this;
      let params = {
        tenantId: common.tenantId,
        memberSchemaId: self.memberSchemaId,
        memberFormId: self.memberFormId,
      };
      authService.orderUnique(params).then((data) => {
        if (data.result == 0) {
          self.fieldList = data.content.fields;
          self.oauthInfo = data.content.oauthInfo;
          self.wechatInfo = data.content.oauthInfo.wechat_web;
          self.qqInfo = data.content.oauthInfo.qq;
          window.$sk.loading.hide();
          self.initTab();
        } else {
          window.$sk.tips.show(data["desc"]);
        }
      });
    },
    initTab() {
      //初始化Tab显示
      let self = this;
      //过滤掉不是找回密码的字段
      for (let i = 0; i < self.fieldList.length; i++) {
        // 增加判断如果self.oauthInfo里有微信qq才继续逻辑
        if (
          self.fieldList[i].fieldName == "weChatNum" ||
          self.fieldList[i].fieldName == "qq"
        ) {
          if (!self.oauthInfo.wechat_web) {
            continue;
          }
          if (!self.oauthInfo.qq) {
            continue;
          }
        }

        if (self.fieldList[i].fieldName == "mobile") {
          //判断国家码是否开启 并显示手机提示
          if (self.fieldList[i].isCallingCodeOpen == 1) {
            self.isShowPhoneTips = true;
          }
        }
        if (
          self.fieldList[i].fieldName == "qq" ||
          self.fieldList[i].fieldName == "email" ||
          self.fieldList[i].fieldName == "mobile" ||
          self.fieldList[i].fieldName == "weChatNum"
        ) {
          switch (self.fieldList[i].fieldName) {
            case "qq":
              self.qq = i;
              break;
            case "weChatNum":
              self.weChat = i;
              break;
            case "mobile":
              self.mobile = i;
              break;
            case "email":
              self.email = i;
              break;
          }
          self.uniqueList.push(self.fieldList[i]);
        }
      }
      if (
        self.mobile == -1 &&
        self.qq == -1 &&
        self.email == -1 &&
        self.weChat == -1
      ) {
        common.removeTokenPush("passwordTip", 2);
        // common.routerPush(this, "passwordTip", { type: 2 });
        return;
      }
      window.$sk.loading.hide();
      if (self.mobile >= 0 && self.email >= 0) {
        self.placeHolderDisplayName = "手机/邮箱";
      } else {
        if (self.mobile >= 0) {
          self.placeHolderDisplayName = "手机";
        } else if (self.email >= 0) {
          self.placeHolderDisplayName = "邮箱";
        }
      }
      if (self.uniqueList.length > 0) {
        self.isShowQQ = self.qq >= 0;
        self.isShowWeChat = self.weChat >= 0;
      }
      if (self.weChat >= 0) {
        self.weChatUrl = URLS.updateParam(
          "return_url",
          window.location.href.replace("retrievePassword", "setPassword"),
          self.oauthInfo.wechat["loginUrl"]
        ); //WAP端调用
        // self.weChatUrl = self.oauthInfo.wechat["loginUrl"] + "?return_url=" + window.location.href.replace("findpassword",
        //   "setpassword");//WAP端调用
        // self.createWecharQrcode();//PC端的调用
      }
    },
    wapWeChatLogin() {
      let self = this;
      if (self.weChat >= 0) {
        window.$sk.goto(
          self.oauthInfo.wechat["loginUrl"] +
            "&return_url=" +
            encodeURIComponent(
              window.location.href.replace("retrievePassword", "setPassword")
            ) +
            +(window.location.hash.indexOf("?") > -1 ? "&" : "?") +
            "scope=snsapi_userinfo"
        ); //WAP端调用+ '&scope=snsapi_userinfo';
      }
    },
    pcWeChatLogin() {
      let self = this;
      if (self.weChat >= 0) {
        window.$sk.goto(
          self.wechatInfo.loginUrl +
            "?return_url=" +
            encodeURIComponent(
              window.location.href.replace("retrievePassword", "setPassword")
            )
        ); //WAP端调用+ '&scope=snsapi_userinfo';
      }
    },
    qqLogin() {
      let self = this;
      if (self.qq >= 0 && self.qqInfo.loginUrl != "") {
        window.$sk.goto(
          self.qqInfo.loginUrl +
            "?return_url=" +
            encodeURIComponent(
              window.location.href.replace("retrievePassword", "setPassword")
            )
        );
      }
    },
    skUserEnd() {
      let json = window.$sk.template.get();
      common.register(json);
      this.initConfig();
      authService
        .getForNewForm({
          tenantId: common.tenantId,
          memberFormId: common.memberFormId,
          schemaId: common.schemaId,
        })
        .then((res) => {
          if (res.result != 0) return;
          let formInfo = res.content;
          common.handPage(formInfo);
          window.$sk.template.update({
            type: "link",
            data: {
              identity: 1,
              weChatId: formInfo.authWeChatId || 0,
              skObjectType: "member",
              skObjectId: self.memberFormId,
              meetingInstanceId: "",
              meetingType: "",
              skIsNotLink: "",
              memberFormId: "",
            },
          });
        });
    },
    skLinkEnd() {
      this.load();
    },
  },
  created() {
    window.$sk.loading.show();
    this.sk = window.$sk.template.module(this);
  },
  mounted() {
    // this.load();
  },
  beforeDestroy() {
    this.sk.unsubscribe();
  },
};
